export const GET_BEST_INSURANCE =  'GET_BEST_INSURANCE';
export const GET_BEST_INSURANCE_SUCCESS =  'GET_BEST_INSURANCE_SUCCESS';
export const GET_BEST_INSURANCE_FAILED =  'GET_BEST_INSURANCE_FAILED';